/**
 * 带全选的checkbox
 */
<template>
    <el-checkbox-group v-model="valueList" :disabled="disabled" class="clearfix">
        <el-checkbox :indeterminate="isIndeterminate" @change="checkedAllChange" :label="allValue" class="float-l">全选</el-checkbox>
        <el-checkbox v-for="item in itemList" :key="item.key" :label="item.value" @change="checkedChange" class="float-l">
            {{ item.name }}
        </el-checkbox>
    </el-checkbox-group>
</template>

<script>
export default {
    name: 'CheckboxAll',
    props: {
        value: Array,
        options: Array,
        props: {
            type: Object,
            required: true,
            default: () => {
                return {
                    key: 'id',
                    value: 'value',
                    name: 'name'
                };
            }
        },
        defaultAll: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
        indeterminate: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            allValue: 'all_' + new Date().getTime(),
            realList: [],
            valueList: [],
            isIndeterminate: false
        };
    },
    created() {
        if (this.defaultAll) {
            this.setAllValueList();
        }
    },
    methods: {
        setAllValueList() {
            let arr = [];
            let realArr = [];
            if (this.$isNotEmpty(this.options)) {
                this.options.forEach(item => {
                    arr.push(item[this.props.value]);
                    realArr.push(item[this.props.value]);
                });
            }
            this.valueList = arr.push(this.allValue);
            this.realList = realArr;
        },
        checkedAllChange(val) {
            if (val) {
                this.setAllValueList();
            } else {
                this.valueList = [];
                this.realList = [];
            }
            this.$nextTick(() => {
                this.$emit('change', this.realList);
            });
            if (this.indeterminate) {
                this.isIndeterminate = false;
            }
        },
        checkedChange(val) {
            let valueArr = [].concat(this.valueList);
            if (val) { // 如果是选中，判断所有项目是否已经全选,如果已经全选，将valueList 添加到
                if (this.options.length === valueArr.length) {
                    this.valueList.push(this.allValue);
                }
            } else {
                let allValueIdx = valueArr.indexOf(this.allValue);
                if (allValueIdx > -1) {
                    valueArr.splice(allValueIdx, 1);
                    this.valueList.splice(allValueIdx, 1);
                }
            }
            this.realList = valueArr;
            this.$nextTick(() => {
                this.$emit('change', valueArr);
            });
        }
    },
    computed: {
        itemList() {
            let arr = [];
            this.options.forEach(item => {
                let keyField = this.$isNotBlank(this.props.key) ? this.props.key : this.props.value;
                arr.push({
                    key: item[keyField],
                    value: item[this.props.value],
                    name: item[this.props.name]
                });
            });
            return arr;
        }
    },
    watch: {
        value: {
            handler(val) {
                if (val) {
                    this.valueList = [].concat(val);
                    this.realList = val;
                    if (this.$isNotEmpty(this.options) && val.length === this.options.length) {
                        this.valueList.push(this.allValue);
                    }
                } else {
                    this.valueList = [];
                    this.realList = [];
                }
            },
            deep: true,
            immediate: true
        },
        realList: {
            handler(val) {
                if (this.indeterminate) {
                    this.isIndeterminate = val.length > 0 && val.length < this.options.length;
                }
                this.$emit('input', val);
            },
            deep: true,
            immediate: true
        },
        options: {
            handler(val) {
                if (this.defaultAll) {
                    this.setAllValueList();
                }
            },
            deep: true,
            immediate: true
        }
    }
};
</script>

<style scoped>
</style>
